import { useMutation } from '@tanstack/react-query';
import { exportCallsCSV } from 'services/api/getCallsData';

export const useExportCallsCSV = () => {
    const {
        mutate: exportCalls,
        isPending: isExporting,
        ...rest
    } = useMutation({
        mutationFn: exportCallsCSV,
    });

    return { exportCalls, isExporting, ...rest };
};
